import { render } from "./component-adress-office.vue?vue&type=template&id=b544ed62"
import script from "./component-adress-office.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-office.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-office.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b544ed62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b544ed62', __exports__)) {
    api.reload('b544ed62', __exports__)
  }
  
  module.hot.accept("./component-adress-office.vue?vue&type=template&id=b544ed62", () => {
    api.rerender('b544ed62', render)
  })

}


export default __exports__